// admin.index.tsx
// Route index de /admin — redirige vers le tableau de bord administrateur.

import { createFileRoute } from "@tanstack/react-router";

import { AdminDashboardPage } from "@/presentation/pages/AdminDashboardPage";

export const Route = createFileRoute("/admin/")({
  component: AdminDashboardPage,
});
